<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Gerenciamento de percentual de estoque</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3" />

            <div class="mb-3" v-show="!loading">
                <div class="top-button-container">
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary mr-3 dropdown-toggle" data-toggle="dropdown"
                            :disabled="openingFilterModal">
                            Filtro
                            <Loading v-show="openingFilterModal" />
                        </button>

                        <div class="dropdown-menu">
                            <span class="dropdown-item" @click="showFilterModal()">
                                Geral
                            </span>

                            <p class="dropdown-divider"></p>

                            <span class="dropdown-item" @click="showFilterByFileModal()">
                                Por planilha
                            </span>
                        </div>
                    </div>

                    <button type="button" class="btn btn-outline-secondary" v-show="hasProductList"
                        @click="showSelectChannelModal()">
                        Aplicar novos percentuais
                    </button>

                    <div class="btn-group float-right">
                        <button class="btn btn-outline-danger mr-3" v-show="hasProductLogList"
                            @click="showModalBatchLogs()">
                            Existem {{ numLogs }} inconsistências
                        </button>

                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                data-toggle="dropdown">
                                Ações do lote
                            </button>

                            <div class="dropdown-menu">
                                <span class="dropdown-item" @click="showModalClearCurrentBatchItems(currentBatch)">
                                    Limpar lote
                                </span>

                                <p class="dropdown-divider"></p>

                                <span class="dropdown-item" @click="showModalDeleteBatch(currentBatch)">
                                    Excluir lote
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="modal" id="muven-product-batch-list-filter-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Filtro de produtos</h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12 col-md-6 form-group">
                                        <label>Nome</label>
                                        <input type="text" class="form-control" v-model="productBatchFilterForm.name" />
                                    </div>

                                    <div class="col-12 col-md-3 form-group">
                                        <label>Código SKU</label>
                                        <input type="text" class="form-control"
                                            v-model="productBatchFilterForm.skuCode" />
                                    </div>

                                    <div class="col-12 col-md-3 form-group">
                                        <label>Código EAN</label>
                                        <input type="text" class="form-control"
                                            v-model="productBatchFilterForm.eanCode" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Descrição</label>
                                        <input type="text" class="form-control"
                                            v-model="productBatchFilterForm.description" />
                                    </div>

                                    <div class="col-12 col-md-8 form-group">
                                        <label>Qualidade</label>
                                        <multiselect v-model="productBatchFilterForm.qualityList" :options="qualityList"
                                            :multiple="true" :show-labels="false" label="description" track-by="enum"
                                            placeholder="" />
                                    </div>

                                    <div class="col-12 col-md-4 form-group">
                                        <label>Status</label>
                                        <multiselect v-model="productBatchFilterForm.isActive"
                                            :options="isActiveOptions" :multiple="false" :show-labels="false"
                                            label="description" track-by="bool" placeholder="" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Vinculado às categorias</label>
                                        <multiselect v-model="productBatchFilterForm.categoryList"
                                            :options="categoryList" :multiple="true" :show-labels="false" label="name"
                                            track-by="id" placeholder="" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Vinculado às marcas</label>
                                        <multiselect v-model="productBatchFilterForm.brandList" :options="brandList"
                                            :multiple="true" :show-labels="false" label="name" track-by="id"
                                            placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary"
                                    @click="getProductsWithFilter(currentBatch, productBatchFilterForm)"
                                    :disabled="loadingFilter || !this.productBatchFilterForm.isFilterFilled()">
                                    Adicionar ao lote

                                    <Loading v-show="loadingFilter" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="clearFilter()">Restaurar</button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeFilterModal()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-list-filter-by-file-modal">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5>Filtro por planilha</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <div class="muven-tip muven-tip-standalone tip-info mb-3">
                                        <fa icon="info" class="tip-icon" />
                                        <p>Importe os produtos através de uma planilha com extensão .CSV ou .XLSX.</p>
                                        <p>Fique atento a estes <b>pontos importantes:</b> </p>
                                        <ul class="mb-0 pl-4">
                                            <li>A <b>ordem</b> das colunas na planilha é importante. O correto é que a
                                                primeira coluna seja referente ao "Código do Produto" (SKU ou Código
                                                retaguarda), a segunda referente ao "Percentual" a ser ajustado;</li>
                                            <li>Antes de aplicar os novos percentuais no canal, confirme se não existe
                                                nenhuma inconsitência a ser resolvida.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div v-show="loadingFileSheet">
                                    <label>Preparando lista...
                                        <Loading />
                                    </label>
                                </div>

                                <div v-show="!loadingFileSheet">
                                    <label>Planilha (.CSV ou .XLSX)</label>
                                    <input type="file" accept=".csv,.xls,.xlsx"
                                        id="muven-product-batch-list-filter-by-file-input" @change="fileChosenHandler"
                                        class="form-control" />
                                </div>

                                <div class="mt-3 row" v-show="hasProductColumnsFromFile">
                                    <div class="col-12 col-md-3">
                                        <label>SKU</label>
                                        <multiselect
                                            v-model="productBatchItemFromFileUpdateStockPercentualFormModel.skuCode"
                                            :options="productBatchItemFromFileUpdateStockPercentualFormModel.columnList"
                                            :multiple="false" :show-labels="false" @select="updateItemListSkuHandler"
                                            @remove="removeItemListSkuHandler"
                                            :class="{ 'select-error': !productBatchItemFromFileUpdateStockPercentualFormModel.hasSkuCodeColumn() && !productBatchItemFromFileUpdateStockPercentualFormModel.hasCodeSourceColumn() }"
                                            label="description" track-by="pos" placeholder="" />
                                    </div>

                                    <div class="col-12 col-md-3">
                                        <label>Código retaguarda</label>
                                        <multiselect
                                            v-model="productBatchItemFromFileUpdateStockPercentualFormModel.codeSource"
                                            :options="productBatchItemFromFileUpdateStockPercentualFormModel.columnList"
                                            :multiple="false" :show-labels="false"
                                            @select="updateItemListCodeSourceHandler"
                                            @remove="removeItemListCodeSourceHandler"
                                            :class="{ 'select-error': !productBatchItemFromFileUpdateStockPercentualFormModel.hasSkuCodeColumn() && !productBatchItemFromFileUpdateStockPercentualFormModel.hasCodeSourceColumn() }"
                                            label="description" track-by="pos" placeholder="" />
                                    </div>                                    
                                    <div class="col-12 col-md-3">
                                        <label>Percentual</label>
                                        <multiselect
                                            v-model="productBatchItemFromFileUpdateStockPercentualFormModel.stockPercentage"
                                            :options="productBatchItemFromFileUpdateStockPercentualFormModel.columnList"
                                            :multiple="false" :show-labels="false" @select="updateItemPercentualHandler"
                                            @remove="removeItemPercentualHandler"
                                            :class="{ 'select-error': !productBatchItemFromFileUpdateStockPercentualFormModel.hasPercentualColumn() }"
                                            label="description" track-by="pos" placeholder="" />
                                    </div>

                                    <div class="col-12"
                                        v-show="!productBatchItemFromFileUpdateStockPercentualFormModel.isValid()">
                                        <small class="text-danger">SKU ou CÓDIGO RETAGUARDA devem estar preenchidos.
                                            Assim como s coluna "PERCENTUAL".</small>
                                    </div>
                                </div>

                                <div v-show="hasProductListFromFile" class="mt-3">
                                    <div class="sku-info">
                                        <label>SKU</label>
                                    </div>

                                    <div class="code-source-info">
                                        <label>Código retaguarda</label>
                                    </div>
                                    <div class="percentual-info">
                                        <label>Percentual</label>
                                    </div>
                                </div>

                                <div class="table-responsive" v-show="hasProductListFromFile">
                                    <table class="table table-sm table-striped">
                                        <tbody>
                                            <tr v-for="(item, index) in productBatchItemFromFileUpdateStockPercentualFormModel.itemList"
                                                :key="index">
                                                <td class="sku-info">{{ item.skuCode | infoOrPlaceholder }}</td>
                                                <td class="code-source-info">{{ item.codeSource | infoOrPlaceholder }}
                                                </td>
                                                <td class="percentual-info">{{ item.stockPercentage |
                                                    infoOrPlaceholder }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary"
                                    @click="addItemsByFile(currentBatch, productBatchItemFromFileUpdateStockPercentualFormModel)"
                                    :disabled="loadingFilterByFile || !productBatchItemFromFileUpdateStockPercentualFormModel.isValid()">
                                    Adicionar ao lote

                                    <Loading v-show="loadingFilterByFile" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="clearFilterByFile()">Restaurar</button>

                                <button class="btn btn-outline-secondary" @click="closeFilterByFileModal()">
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-management-by-channel-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Aplicar novos percentuais para o canal</h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12 form-group">
                                        <label>Canal</label>
                                        <SelectWrapperCmp
                                            :show-remove-button="productBatchStockPercentageManagementByChannelModel.hasChannels()"
                                            @removed="handleproductBatchStockPercentageManagementByChannelModelRemoval">
                                            <template v-slot:select>
                                                <multiselect
                                                    v-model="productBatchStockPercentageManagementByChannelModel.channelsWrapper"
                                                    :options="channelList" :multiple="true" :show-labels="false"
                                                    label="name" track-by="id" placeholder="" />
                                            </template>
                                        </SelectWrapperCmp>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary"
                                    :disabled="batchIsNotReady() || submittingNow"
                                    @click="submitStockPercentualUpdateManagementByChannel(currentBatch, productBatchStockPercentageManagementByChannelModel)">
                                    Executar
                                    <Loading v-show="submittingNow" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeStockManagementByChannelModal()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-clear-current-batch-item-list-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Exclusão de itens do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir os itens do lote <b>{{ currentBatch.name }}</b>?
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-danger" :disabled="clearingCurrentBatch"
                                    @click="clearBatchHandler(currentBatch)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, excluir os itens

                                    <Loading v-show="clearingCurrentBatch" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeModalClearCurrentBatchItems()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-delete-batch-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Exclusão de lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir o lote <b>{{ chosenBatchForExclusion.name }}</b>?
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-danger" :disabled="deletingCurrentBatch"
                                    @click="deleteBatchHandler(chosenBatchForExclusion)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, excluir o lote

                                    <Loading v-show="deletingCurrentBatch" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeModalDeleteBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-delete-product-from-batch-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Remover item do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir o produto
                                        <b>{{ chosenProductForExclusion.name }}</b> <b
                                            v-show="!chosenProductForExclusion.hasChildren()">({{
                                                chosenProductForExclusion.skuCode
                                            }})</b>
                                        <span v-show="chosenProductForExclusion.hasChildren()"> e suas variações</span>?
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-danger"
                                    :disabled="deletingProductBatchItem"
                                    @click="deleteProductFromTheBatchHandler(currentBatch, chosenProductForExclusion)">
                                    <fa icon="exclamation-triangle" />
                                    Sim, remover do lote

                                    <Loading v-show="deletingProductBatchItem" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeModalDeleteProductFromBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-batch-delete-product-variation-from-batch-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Remover variação do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja remover a variação
                                        <b>{{ chosenProductVariationForExclusion.getVariationsStringified() }}</b> do
                                        produto
                                        <b>{{ chosenProductForExclusion.name }}</b>?
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-danger"
                                    :disabled="deletingProductBatchItem"
                                    @click="deleteProductVariationFromTheBatchHandler(currentBatch, chosenProductForExclusion, chosenProductVariationForExclusion)">
                                    <fa icon="exclamation-triangle" />
                                    Sim, remover do lote

                                    <Loading v-show="deletingProductBatchItem" />
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    @click="closeModalDeleteProductVariationFromBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" tabindex="-1" role="dialog" id="muven-product-batch-logs-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Inconsistências</h5>
                            </div>
                            <div class="modal-body">
                                <NothingFound v-show="!hasProductLogList" />
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Mensagem</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(log, index) in productLogList" :key="index">
                                            <td>{{ log.info.message }}</td>
                                            <td>
                                                <span v-show="log.isStatusError()">
                                                    <span class="muven-td-icon">
                                                        <fa icon="exclamation-triangle" class="text-danger" />
                                                    </span>

                                                    Erro
                                                </span>
                                                <span v-show="log.isStatusSuccess()">
                                                    <span class="muven-td-icon">
                                                        <fa icon="check-circle" class="text-success" />
                                                    </span>

                                                    Sucesso
                                                </span>
                                                <span v-show="log.isStatusWarning()">
                                                    <span class="muven-td-icon">
                                                        <fa icon="info-circle" class="text-info" />
                                                    </span>

                                                    Aviso
                                                </span>
                                                <span v-show="log.isStatusIgnored()">
                                                    <span class="muven-td-icon">
                                                        <fa icon="ban" class="text-muted" />
                                                    </span>

                                                    Ignorado
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-outline-secondary" @click="closeModalBatchLogs()">
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Loading page v-show="loading" />

                <NothingFound v-if="!loading && !hasProductList" />

                <div class="table-responsive" v-show="hasProductList && !loading">
                    <table class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th class="product-name-width">Nome</th>
                                <th class="product-type-width">Tipo</th>
                                <th>SKU <br> Cd. retaguarda</th>
                                <th>Novo Percentual</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody v-for="(productBatchItem, index) in productList" :key="index">
                            <tr>
                                <td>{{ productBatchItem.product.name }}</td>
                                <td>
                                    <span v-show="!productBatchItem.product.hasChildren()">Simples</span>
                                    <span v-show="productBatchItem.product.hasChildren()"
                                        @click="toggleGridExhibition(productBatchItem.product)">
                                        Grade

                                        <fa icon="chevron-down" class="icon-grid-toggle" :class="{
                                            'show-grid': productBatchItem.product.isGridVisible,
                                        }" />
                                    </span>
                                </td>
                                <td>
                                    <span>{{ productBatchItem.product.skuCode | infoOrPlaceholder }}</span>
                                    <br>
                                    <span>{{ productBatchItem.product.codeSource | infoOrPlaceholder }}</span>
                                </td>
                                <td>
                                    <div v-if="productBatchItem.isBeingModified">
                                        <span v-if="!productBatchItem.product.hasChildren()">
                                            <input v-if="productBatchItem.payload" type="number" min="0" step="0.01"
                                                class="form-control"
                                                :disabled="productBatchItem.product.loadingListAction"
                                                v-model="productBatchItem.payload.stockPercentage" />
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                    <div v-else>
                                        <span
                                            v-if="!productBatchItem.product.hasChildren() && productBatchItem.payload">
                                            <span>{{ Math.floor(productBatchItem.payload.stockPercentage) }}%</span>
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </td>

                                <td class="text-right muven-td-with-multiple-buttons">
                                    <div v-show="!productBatchItem.isBeingModified">
                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            v-if="!productBatchItem.product.hasChildren()"
                                            @click="startProductModification(productBatchItem)">
                                            Editar
                                        </button>

                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            @click="showModalDeleteProductFromBatch(productBatchItem.product)">
                                            <fa icon="trash-alt" />
                                        </button>
                                    </div>

                                    <div v-show="productBatchItem.isBeingModified">
                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            v-if="!productBatchItem.product.hasChildren()"
                                            :disabled="productBatchItem.product.loadingListAction"
                                            @click="saveProductModification(productBatchItem)">
                                            Gravar
                                            <Loading v-show="productBatchItem.product.loadingListAction" />
                                        </button>

                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            v-if="!productBatchItem.product.hasChildren()"
                                            :disabled="productBatchItem.product.loadingListAction"
                                            @click="stopProductModification(productBatchItem)">

                                            <fa icon="window-close" />
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr class="product-child" v-for="(child, index) in productBatchItem.product.children"
                                :key="index" v-show="productBatchItem.product.isGridVisible">
                                <td>{{ child.getVariationsStringified() }}</td>
                                <td>Filho</td>
                                <td>
                                    <span>{{ child.skuCode | infoOrPlaceholder }}</span>
                                    <br>
                                    <span>{{ child.codeSource | infoOrPlaceholder }}</span>
                                </td>
                                <td>
                                    <div v-if="child.isBeingModified">
                                        <span>
                                            <input v-if="productBatchItem.payload" type="number" min="0" step="0.01"
                                                class="form-control" :disabled="child.loadingListAction"
                                                v-model="child.payload.stockPercentage" />
                                        </span>
                                    </div>
                                    <div v-else>
                                        <div v-if="child.payload.new.stockPercentage">
                                            <span>{{ Math.floor(child.payload.new.stockPercentage) }}%</span>
                                        </div>
                                        <div v-else-if="productBatchItem.payload">
                                            <span>{{ Math.floor(child.payload.stockPercentage) }}%</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right muven-td-with-multiple-buttons">
                                    <div v-show="!child.isBeingModified">
                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            @click="startProductModification(child)">
                                            Editar
                                        </button>

                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            @click="showModalDeleteProductVariationFromBatch(productBatchItem.product, child)">
                                            <fa icon="trash-alt" />
                                        </button>
                                    </div>

                                    <div v-show="child.isBeingModified">
                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            :disabled="child.loadingListAction" @click="saveChildModification(child)">
                                            Gravar
                                            <Loading v-show="child.loadingListAction" />
                                        </button>

                                        <button type="button" class="btn btn-default text-muted btn-sm"
                                            :disabled="child.loadingListAction" @click="stopProductModification(child)">

                                            <fa icon="window-close" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="productList.length" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ProductBatchItemListFilterModel } from '@/product/models/ProductBatchItemListFilterModel'
import modalService from '@/utils/services/ModalService'
import { flattenTree } from '../../utils/normalizers/TreeNormalizer'
import categoryService from '../../category/services/CategoryService'
import brandService from '../../brand/services/BrandService'
import ConfirmationExclusionModalCmp from '../../utils/components/ConfirmationExclusionModalCmp.vue'
import { ProductBatchModel } from '../models/ProductBatchModel'
import { mapState } from 'vuex'
import productBatchService from '../services/ProductBatchService'
import { cloneDeep } from 'lodash'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import SelectWrapperCmp from '@/utils/components/SelectWrapperCmp'
import { ProductModel } from '../models/ProductModel'
import channelService from '../../channel/services/ChannelService'
import { ProductBatchItemModel } from '../models/ProductBatchItemModel'
import XLSX from 'xlsx';
import { ProductBatchItemFromFileUpdateStockPercentualFormModel } from '../models/ProductBatchItemFromFileUpdateStockPercentualFormModel'
import { ProductBatchStockPercentageManagementByChannelModel } from '../models/ProductBatchStockPercentageManagementByChannelModel'
import { sub } from 'date-fns'


const ID_FILTER_MODAL = '#muven-product-batch-list-filter-modal'
const ID_FILTER_BY_FILE_MODAL = '#muven-product-batch-list-filter-by-file-modal'
const ID_BATCH_LOGS_MODAL = '#muven-product-batch-logs-modal'
const ID_STOCK_PERCENTAGE_MANAGEMENT_BY_CHANNEL_MODAL = '#muven-product-batch-management-by-channel-modal'
const ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL = '#muven-product-batch-clear-current-batch-item-list-modal'
const ID_DELETE_BATCH_MODAL = '#muven-product-batch-delete-batch-modal'
const ID_DELETE_PRODUCT_FROM_BATCH_MODAL = '#muven-product-batch-delete-product-from-batch-modal'
const ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL = '#muven-product-batch-delete-product-variation-from-batch-modal'

export default {
    name: 'ProductListBatchStockPercentageManagementView',
    components: {
        ConfirmationExclusionModalCmp,
        SelectWrapperCmp,
    },
    filters: {
        infoOrPlaceholder,
    },
    data() {
        return {
            loading: false,
            loadingFilter: false,
            loadingFilterByFile: false,
            openingFilterModal: false,
            clearingCurrentBatch: false,
            deletingCurrentBatch: false,
            deletingProductBatchItem: false,
            submittingNow: false,
            loadingFileSheet: false,
            newBatch: new ProductBatchModel(),
            currentBatch: new ProductBatchModel(),
            productBatchFilterForm: new ProductBatchItemListFilterModel(),
            productBatchFilterFormSubmitted: new ProductBatchItemListFilterModel(),
            productBatchStockPercentageManagementByChannelModel: new ProductBatchStockPercentageManagementByChannelModel(),
            chosenBatchForExclusion: new ProductModel(),
            chosenProductForExclusion: new ProductModel(),
            chosenProductVariationForExclusion: new ProductModel(),
            batchList: [],
            productList: [],
            productLogList: [],
            categoryList: [],
            brandList: [],
            channelList: [],
            qualityList: ProductBatchItemListFilterModel.getQualityList(),
            productBatchItemFromFileUpdateStockPercentualFormModel: new ProductBatchItemFromFileUpdateStockPercentualFormModel(),
            isActiveOptions: [
                {
                    bool: true,
                    description: 'Ativo',
                },
                {
                    bool: false,
                    description: 'Inativo',
                },
            ],
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Lotes de produtos`,
                    path: '/produtos/lotes',
                },
                {
                    id: 2,
                    description: `Carregando informações do lote`,
                    path: '',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        try {
            this.batchList = await productBatchService.getBatchList()

            if (!this.batchList.length) {
                this.$router.push('/produtos/lotes')
                return
            }

            this.channelList = await channelService.getChannels()
            this.currentBatch = this.batchList.find((b) => String(b.id) === (this.$route.params.id))

            this.productBatchStockPercentageManagementByChannelModel = new ProductBatchStockPercentageManagementByChannelModel(this.currentBatch.payload)

            this._updateBreadcrumbScenario(this.currentBatch)

            const result = await Promise.all([
                productBatchService.getBatchItems(this.currentBatch),
                productBatchService.getBatchItemsLogs(this.currentBatch)
            ])

            this.productList = this._normalizeProductBatchItems(result[0])
            this.productLogList = result[1]
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getProductsWithFilter(currentBatch, filterList) {
            this.productBatchItemFilterFormSubmitted = cloneDeep(filterList)
            this.loadingFilter = true

            try {
                // 06524800054133
                const productBatchItemWrapped = await productBatchService.addItems(currentBatch, filterList)
                if (!productBatchItemWrapped.logs) {
                    productBatchItemWrapped.logs = []
                }

                if (!productBatchItemWrapped.items) {
                    productBatchItemWrapped.items = []
                }
                this.productLogList.push(...productBatchItemWrapped.logs)
                const productBatchItemNormalized = this._normalizeProductBatchItemsWrapped(productBatchItemWrapped)

                let parentProductFound = false

                for (const product of this.productList) {
                    if (product.product.hasChildren()) {
                        for (const productBatchItem of productBatchItemNormalized) {
                            if (product.product.id === productBatchItem.product.id) {
                                parentProductFound = true
                                product.product.children.push(...productBatchItem.product.children)
                                break
                            }
                        }
                    }
                }

                if (!parentProductFound) {
                    this.productList.unshift(...productBatchItemNormalized)
                }

                await this.closeFilterModal()
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingFilter = false
        },
        async clearBatchHandler(currentBatch) {
            this.clearingCurrentBatch = true

            try {
                await productBatchService.clearBatchItemList(currentBatch.id)

                this._clearProductList()
                this.closeModalClearCurrentBatchItems()

                this.$floatingAlert.success({
                    message: `Lote <b>${currentBatch.name}</b> limpo com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.clearingCurrentBatch = false
        },
        async addItemsByFile(currentBatch, productBatchItemFromFileUpdateStockPercentualFormModel) {
            this.loadingFilterByFile = true

            const itemsToSend = productBatchItemFromFileUpdateStockPercentualFormModel.normalize();

            try {
                const productBatchItemWrapped = await productBatchService.addItemsFromFileUpdateStockPercentual(currentBatch, itemsToSend)
                this.productLogList.push(...productBatchItemWrapped.logs)
                const productBatchItemNormalized = this._normalizeProductBatchItemsWrapped(productBatchItemWrapped)

                let parentProductFound = false

                for (const product of this.productList) {
                    if (product.product.hasChildren()) {
                        for (const productBatchItem of productBatchItemNormalized) {
                            if (product.product.id === productBatchItem.product.id) {
                                parentProductFound = true
                                product.product.children.push(...productBatchItem.product.children)
                                break
                            }
                        }
                    }
                }

                if (!parentProductFound) {
                    this.productList.unshift(...productBatchItemNormalized)
                }

                this.closeFilterByFileModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilterByFile = false
        },
        async deleteBatchHandler(batch) {
            this.deletingCurrentBatch = true

            try {
                await productBatchService.deleteBatch(batch.id)

                this.$floatingAlert.success({
                    message: `Lote <b>${batch.name}</b> excluído com sucesso.`,
                })

                await modalService.hide(ID_DELETE_BATCH_MODAL)
                this.$router.push('/produtos/lotes')
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingCurrentBatch = false
        },
        async deleteProductFromTheBatchHandler(currentBatch, product) {
            this.deletingProductBatchItem = true

            try {
                await this._removeProductBatchItemFromTheList(currentBatch, product)
                this.closeModalDeleteProductFromBatch()

                this.$floatingAlert.success({
                    message: `Produto <b>${product.name}</b> (${product.skuCode}) removido do lote <b>${currentBatch.name}</b> com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingProductBatchItem = false
        },
        async deleteProductVariationFromTheBatchHandler(currentBatch, product, variation) {
            this.deletingProductBatchItem = true

            try {
                await productBatchService.deleteItemFromBatch(currentBatch.id, variation.id)

                let foundVariation = false

                for (let i = 0; i < this.productList.length; i++) {
                    if (this.productList[i].product.id === product.id) {
                        for (let j = 0; j < this.productList[i].product.children.length; j++) {
                            if (this.productList[i].product.children[j].id === variation.id) {
                                this.productList[i].product.children.splice(j, 1)
                                foundVariation = true
                                break
                            }
                        }

                        if (foundVariation) {
                            if (!this.productList[i].product.hasChildren()) {
                                await this._removeProductBatchItemFromTheList(currentBatch, product)
                            }

                            break
                        }
                    }
                }

                this.closeModalDeleteProductVariationFromBatch()

                this.$floatingAlert.success({
                    message: `Variação <b>${product.getVariationsStringified()}</b> do produto <b>${product.name} (${product.skuCode})</b> removido do lote <b>${currentBatch.name}</b> com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingProductBatchItem = false
        },
        async showFilterModal() {
            this.openingFilterModal = true

            try {
                if (!this.categoryList.length || !this.brandList.length) {
                    const result = await Promise.all([
                        categoryService.getCategoryTree(),
                        brandService.getAllBrands(),
                    ])

                    this.categoryList = flattenTree(result[0])
                    this.brandList = result[1]
                }

                await modalService.show(ID_FILTER_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.openingFilterModal = false
        },
        clearFilter() {
            this.productBatchFilterForm = new ProductBatchItemListFilterModel()
        },
        async closeFilterModal() {
            await modalService.hide(ID_FILTER_MODAL)
        },
        async showFilterByFileModal() {
            await modalService.show(ID_FILTER_BY_FILE_MODAL)
        },
        clearFilterByFile() {
            document.getElementById('muven-product-batch-list-filter-by-file-input').value = null
            this.productBatchItemFromFileUpdateStockPercentualForm = new ProductBatchItemFromFileUpdateStockPercentualFormModel()
            this.productBatchItemFromFileUpdateStockPercentualFormModel.itemList = [];
        },
        async closeFilterByFileModal() {
            await modalService.hide(ID_FILTER_BY_FILE_MODAL)
        },
        async showModalBatchLogs() {
            await modalService.show(ID_BATCH_LOGS_MODAL)
        },
        async closeModalBatchLogs() {
            await modalService.hide(ID_BATCH_LOGS_MODAL)
        },
        batchIsNotReady() {
            const model = this.productBatchStockPercentageManagementByChannelModel;
            const ret = model && model.channelsWrapper && model.channelsWrapper.length > 0;
            return !ret;
        },
        async submitStockPercentualUpdateManagementByChannel(currentBatch, productBatchStockPercentageManagementByChannelModel) {
            this.submittingNow = true

            try {
                await productBatchService.executeBatchAction(currentBatch.id, productBatchStockPercentageManagementByChannelModel.normalize())

                this.$floatingAlert.info({
                    message: 'Processamento dos percentuais de estoque por canal em andamento.',
                })

                await this.closeStockManagementByChannelModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingNow = false
        },
        async showSelectChannelModal() {
            await modalService.show(ID_STOCK_PERCENTAGE_MANAGEMENT_BY_CHANNEL_MODAL)
        },
        async closeStockManagementByChannelModal() {
            await modalService.hide(ID_STOCK_PERCENTAGE_MANAGEMENT_BY_CHANNEL_MODAL)
        },
        async showModalClearCurrentBatchItems() {
            await modalService.show(ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL)
        },
        async closeModalClearCurrentBatchItems() {
            await modalService.hide(ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL)
        },
        async showModalDeleteBatch(batch) {
            this.chosenBatchForExclusion = batch
            await modalService.show(ID_DELETE_BATCH_MODAL)
        },
        async closeModalDeleteBatch() {
            await modalService.hide(ID_DELETE_BATCH_MODAL)
        },
        async showModalDeleteProductFromBatch(product) {
            this.chosenProductForExclusion = cloneDeep(product)

            await modalService.show(ID_DELETE_PRODUCT_FROM_BATCH_MODAL)
        },
        async closeModalDeleteProductFromBatch() {
            await modalService.hide(ID_DELETE_PRODUCT_FROM_BATCH_MODAL)
        },
        async showModalDeleteProductVariationFromBatch(product, variation) {
            this.chosenProductForExclusion = cloneDeep(product)
            this.chosenProductVariationForExclusion = cloneDeep(variation)

            await modalService.show(ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL)
        },
        async closeModalDeleteProductVariationFromBatch() {
            await modalService.hide(ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL)
        },
        handleproductBatchStockPercentageManagementByChannelModelRemoval() {
            this.productBatchStockPercentageManagementByChannelModel.clearChannels()
        },
        toggleGridExhibition(product) {
            product.isGridVisible = !product.isGridVisible
        },
        startProductModification(p) {
            p.setBeingModifiedStatus(true)
            p.payload.updateValuesBeforeChange()
        },
        stopProductModification(p) {
            p.setBeingModifiedStatus(false)
            p.payload.resetValues()
        },
        async saveProductModification(p) {
            p.product.loadingListAction = true

            try {
                await productBatchService.updateBatchItemProduct(this.currentBatch, p.product.id, p.payload)
                p.setBeingModifiedStatus(false)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            p.product.loadingListAction = false
        },
        async saveChildModification(c) {
            c.loadingListAction = true

            try {
                await productBatchService.updateBatchItemProduct(this.currentBatch, c.id, c.payload)
                c.setBeingModifiedStatus(false)
                c.payload.new.stockPercentage = null;
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            c.loadingListAction = false
        },
        fileChosenHandler({ target }) {
            this.loadingFileSheet = true;
            const file = target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });
                /* Update state */
                this.productBatchItemFromFileUpdateStockPercentualFormModel.initializeData(data);
                this.loadingFileSheet = false;
            };

            reader.readAsBinaryString(file);
        },
        updateItemListSkuHandler(col) {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemListSkuInfo(col)
        },
        removeItemListSkuHandler() {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemListSkuInfo(null)
        },
        updateItemListCodeSourceHandler(col) {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemListCodeSourceInfo(col)
        },
        removeItemListCodeSourceHandler() {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemListCodeSourceInfo(null)
        },
        updateItemPercentualHandler(col) {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemPercentualInfo(col)
        },
        removeItemPercentualHandler() {
            this.productBatchItemFromFileUpdateStockPercentualFormModel.updateItemPercentualInfo(null)
        },
        _normalizeProductBatchItems(productBatchItems) {
            return productBatchItems.map((prod) => {
                return new ProductBatchItemModel({
                    product: ProductModel.normalizeV1(prod.product, this.subscriber),
                    payload: prod.payload,
                })
            })
        },
        _normalizeProductBatchItemsWrapped(productBatchItemPercentageWrapped) {
            return productBatchItemPercentageWrapped.items.map((prod) => {
                return new ProductBatchItemModel({
                    product: ProductModel.normalizeV1(prod.product, this.subscriber),
                    payload: prod.payload,
                })
            })
        },
        _clearProductList() {
            this.productList = []
            this.productLogList = []
        },
        _updateBreadcrumbScenario(currentBatch) {
            this.breadcrumbList[2].description = `Gerenciamento de percentual de estoque - ${currentBatch.name}`
        },
        async _removeProductBatchItemFromTheList(currentBatch, product) {
            await productBatchService.deleteItemFromBatch(currentBatch.id, product.id)

            for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i].product.id === product.id) {
                    this.productList.splice(i, 1)
                    break
                }
            }
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
            subscriber: state => state.subscriber,
        }),
        hasBatchList() {
            return this.batchList.length > 0
        },
        hasProductList() {
            return this.productList.length > 0
        },
        hasProductLogList() {
            return this.productLogList.length > 0
        },
        hasProductColumnsFromFile() {
            return this.productBatchItemFromFileUpdateStockPercentualFormModel.columnList.length > 0
        },
        hasProductListFromFile() {
            return this.productBatchItemFromFileUpdateStockPercentualFormModel.itemList.length > 0
        },
        numLogs() {
            return this.productLogList.length
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-primary:disabled,
.btn-primary.disabled {
    background-color: var(--border-strong) !important;
    border-color: var(--border-strong) !important;
    color: var(--text-muted) !important;
    cursor: not-allowed;
}


.product-attributes {
    color: var(--text-muted);
    font-size: .85em;
}

.product-child {
    td {
        &:first-of-type {
            padding-left: 27px;
        }

        .grid-info {
            color: var(--text-muted);
            font-size: .9em;
        }
    }
}

.table {
    thead {
        tr {
            th.product-name-width {
                width: 350px;
            }

            th.product-type-width {
                width: 100px;
            }

            th.product-stock-percentage-width {
                width: 150px;
            }
        }
    }

    tbody {
        tr td {
            .icon-grid-toggle {
                cursor: pointer;
                font-size: .75em;
                color: var(--text-muted);
                margin-right: 15px;
                margin-left: 8px;
                transition: transform .3s ease;

                &.show-grid {
                    transform: rotate(180deg);
                }
            }
        }

        &:last-of-type tr {
            border-bottom: 1px solid var(--border);
        }

        &:nth-of-type(odd) tr {
            background-color: color-mix(in srgb, var(--text-strong) 5%, transparent);

            &:hover {
                background-color: var(--surface-2);
            }
        }
    }
}

.batch-container {
    border: 1px solid var(--border);
    border-radius: 2px;

    .batch-info,
    .batch-actions {
        padding: 8px;
    }

    .batch-info {
        position: relative;

        .batch-remove-button-container {
            position: absolute;
            top: 8px;
            right: 8px;
        }
    }

    .batch-actions {
        overflow-x: hidden;
        border-top: 1px solid var(--border);
        background-color: var(--surface-2);
        text-align: right;
    }
}

#muven-product-batch-logs-modal {
    .modal-body {
        max-height: 400px;
        overflow-y: auto;
    }
}

#muven-product-batch-list-filter-by-file-modal {
    .modal-body {

        .sku-info,
        .code-source-info,
        .percentual-info {
            float: left;
            padding: 8px 16px;
            margin-bottom: -8px;
        }

        .sku-info {
            width: 25%;
            border-left: 1px solid var(--border);
            border-top: 1px solid var(--border);
        }

        .code-source-info {
            width: 25%;
            border-top: 1px solid var(--border);
        }

        .percentual-info {
            width: 25%;
            border-top: 1px solid var(--border);
        }

        .table>tbody>tr td {

            &.sku-info,
            &.code-source-info,
            &.percentual-info {
                border-top: none;
                margin: auto;
            }
        }

        .table-responsive {
            max-height: 250px;
        }
    }
}
</style>